import ContentsTypes from "@shared/enums/contentsTypes";
export const createPricingCardItem = (variant, size, barColor, surtitle, title, description, feature, plusFeature, plusFeatureIcon, featuresOptional, price, priceDetails, buttonUrl, buttonTitle, iconButton) => ({
    key: "items",
    type: "OFFERING_CARD",
    value: "",
    children: [
        { key: "variant", type: ContentsTypes.SELECT, value: variant },
        { key: "size", type: ContentsTypes.SELECT, value: size },
        { key: "barColor", type: ContentsTypes.COLOR, value: barColor },
        { key: "surtitle", type: ContentsTypes.INPUT, value: surtitle },
        { key: "title", type: ContentsTypes.INPUT, value: title },
        { key: "description", type: ContentsTypes.SHORT_TEXT, value: description },
        { key: "features", type: ContentsTypes.TEXT, value: feature },
        { key: "featuresOptional", type: "CHECKBOX", value: featuresOptional },
        { key: "plusFeature", type: ContentsTypes.INPUT, value: plusFeature },
        {
            key: "plusFeatureIcon",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                {
                    key: "icon",
                    type: ContentsTypes.INPUT,
                    value: plusFeatureIcon || "",
                },
                {
                    key: "type",
                    type: ContentsTypes.SELECT,
                    value: "far",
                },
                {
                    key: "color",
                    type: ContentsTypes.COLOR,
                    value: plusFeatureIcon ? "#0000FF" : "white",
                },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
        { key: "price", type: ContentsTypes.INPUT, value: price || "" },
        {
            key: "priceDetails",
            type: ContentsTypes.INPUT,
            value: priceDetails || "",
        },
        {
            key: "button",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                { key: "url", type: ContentsTypes.URL, value: buttonUrl || "" },
                { key: "page", type: "PAGE", value: "" },
                {
                    key: "title",
                    type: ContentsTypes.INPUT,
                    value: buttonTitle || "Découvrir",
                },
                { key: "anchor", type: ContentsTypes.SELECT, value: "" },
                { key: "external", type: "CHECKBOX", value: "false" },
            ],
        },
        {
            key: "iconButton",
            type: ContentsTypes.ICON,
            value: "",
            children: [
                { key: "icon", type: ContentsTypes.INPUT, value: iconButton },
                { key: "type", type: ContentsTypes.SELECT, value: "far" },
                { key: "color", type: ContentsTypes.COLOR, value: "#0000FF" },
                { key: "background", type: ContentsTypes.COLOR, value: "" },
            ],
        },
        {
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
            children: [
                { key: "url", type: ContentsTypes.URL, value: "" },
                { key: "page", type: "PAGE", value: "" },
                { key: "title", type: ContentsTypes.INPUT, value: "" },
                { key: "external", type: "CHECKBOX", value: "false" },
            ],
        },
    ],
});
